<template>
  <div class="com-table balance border">
    <el-row>
      <el-col :span="20"><div class="com-title pr">推广管理</div></el-col>
      <el-col :span="4"><el-button type="primary" @click="deriveDATA">导出</el-button></el-col>
    </el-row>
    <search :data="search.list" @click="updateConditions"></search>
    <div class="tableTip">
      注：周一至周五消费10点左右生成完成<br><span></span>周六、周日消费11点左右生成完成
    </div>
    <el-table
      class="element-table"
      size="small" stripe border
      :data="table.list"
      :highlight-current-row="true"
      :summary-method="getSummaries"
      :show-summary="true"
      :fit="true">
      <template slot="empty">
        <no-data></no-data>
      </template>
      <el-table-column prop="day" label="日期" min-width="100" fixed>
      </el-table-column>
      <el-table-column prop="itemTitle" label="项目名称" min-width="150">
      </el-table-column>
      <!-- <el-table-column prop="click" label="点击量" min-width="70" align="right" header-align="center">
      </el-table-column> -->
      <!--<el-table-column prop="clickPrice" label="平均点击价格（点数）" min-width="100" align="right" header-align="center">-->
        <!--<template slot-scope="scope">-->
          <!--<span v-if="scope.row.click === 0">-</span>-->
          <!--<span v-else>{{parseFloat(scope.row.costCoin / scope.row.click).toFixed(2)}}</span>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <!-- <el-table-column prop="clickPrice" label="平均点击价格（元）" min-width="110" align="right" header-align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.click === 0">-</span>
          <span v-else>{{parseFloat(scope.row.costMoney / scope.row.click).toFixed(2)}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="feedback" label="留言数" min-width="70" align="right" header-align="center">
      </el-table-column>
      <!-- <el-table-column prop="talk" label="有效对话量" min-width="100" align="right" header-align="center">
      </el-table-column> -->
      <el-table-column prop="phone" label="要电话量" min-width="80" align="right" header-align="center">
      </el-table-column>
      <el-table-column prop="total" label="总资源数" min-width="80" align="right" header-align="center">
      </el-table-column>
      <!-- <el-table-column label="有效咨询率" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.click > 0">{{(scope.row.talk * 100 / scope.row.click).toFixed(2)}}%</span>
          <span v-else class="ms-info">-</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="沟通有效率" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.talk > 0">{{(scope.row.phone * 100 / scope.row.talk).toFixed(2) | filterNum}}%</span>
          <span v-else class="ms-info">-</span>
        </template>
      </el-table-column> -->
      <!--<el-table-column prop="costCoin" label="消费点数" min-width="150" align="right" header-align="center">-->
        <!--<template slot-scope="scope">-->
          <!--<span>{{parseFloat(scope.row.costCoin).toFixed(2)}} 点</span>-->
        <!--</template>-->
      <!--</el-table-column>-->
      <el-table-column prop="costCoin" label="消费点数" min-width="90" align="right" header-align="center" v-if="showCostCoin"></el-table-column>
      <el-table-column prop="costMoney" label="消费金额" min-width="90" align="right" header-align="center">
        <template slot-scope="scope">
          <span>{{parseFloat(scope.row.costMoney).toFixed(2)}} 元</span>
        </template>
      </el-table-column>
      <el-table-column label="均价" min-width="80" align="right" header-align="center">
        <template slot-scope="scope">
          <span>{{parseFloat(scope.row.costMoney/scope.row.total).toFixed(2)}} 元</span>
        </template>
      </el-table-column>
      <el-table-column prop="server" label="客服经理" min-width="80">
      </el-table-column>
      <el-table-column prop="saler" label="销售" min-width="60">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="table.pagination.page"
      :total="table.pagination.totalRow"
      :page-size="table.pagination.pageSize"
      :page-sizes="table.pagination.pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
  import moment from 'moment'
  import StatisticsApi from '@/api/statistics'
  import Search from '@/components/common/Search.vue'
  import { SEARCH_CONDITION } from '@/models/client/promote-data'
  import ResponseParse from '@/utils/response-parse'

  export default {
    components: {
      Search
    },
    created () {
      this.search.list = SEARCH_CONDITION
      let date = []
      date[0] = moment().subtract(6, 'days').format('YYYY-MM-DD')
      date[1] = moment().format('YYYY-MM-DD')
      this.search.condition.startTime = date[0]
      this.search.condition.endTime = date[1]
      this.search.list[0].value = date
      StatisticsApi.customerItem({search: {modeType: 1}}, response => {
        let status = response.data.code
        let data = response.data.data
        if (status === '200') {
          let project = []
          data.forEach(item => {
            if (item.status === 1) {
              project.unshift({value: item.title, label: item.title})
            } else {
              project.push({value: item.title, label: item.title, disabled: true})
            }
          })
          this.search.list[1].config.list = project
        }
      })
      this.requestList()
    },
    filters: {
      filterNum (e) {
        return e > 100 ? 100 : e
      }
    },
    data () {
      return {
        showCostCoin: false,
        row: {
          edit: {
            index: 0
          },
          form: {}
        },
        search: {
          list: [],
          pagination: {},
          condition: {}
        },
        table: {
          list: [],
          pagination: {},
          condition: {}
        },
        data: {},
        chartLoading: false
      }
    },
    methods: {
      deriveDATA () {
        console.log(this.search.condition)
        let url = `/rest/customer/report/item-solution-page-reports/extend/export?`
        // this.search.condition.forEach((item, index) => {
        //   if (!Array.isArray(item)) {
        //     url += item + '=' + this.search.condition[index] + '&'
        //   }
        // })
        for (let item in this.search.condition) {
          if (this.search.condition[item]) {
            if (this.search.condition[item].constructor !== Array) {
              url += item + '=' + this.search.condition[item] + '&'
            }
          }
        }
        url = url.slice(0, url.length - 1)
        // console.log(url)
        window.location.href = url
      },
      formatTime (value) {
        return moment(value, 'MM-DD-YYYY hh:mm:ss').format('YYYY-MM-DD')
      },
      requestList () {
        this.chartLoading = true
        const search = Object.assign({}, this.table.pagination, this.search.condition)
        StatisticsApi.promoteData({search: search}, response => {
          let status = response.data.code
          let body = response.data.data || {}
          if (status === '200') {
            this.table.pagination = ResponseParse.pagination(response.headers)
            if (body.length !== 0) {
              body.forEach(item => {
                item.total = item.feedback + item.phone
              })
              if (body[0].costCoin !== null) {
                this.showCostCoin = true
              }
            }
            this.table.list = body
          } else {
            this.table.list = []
          }
          this.chartLoading = false
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        this.search.condition = conditions
        const date = conditions.date || []
        this.search.condition = Object.assign({}, conditions, {startTime: date[0], endTime: date[1]})
        this.requestList()
      },
      getSummaries (param) {
        let {columns, data} = param
        let sums = []

        if (data.length === 0) {
          return sums
        }

        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }

          let values = data.map(item => Number(item[column.property]))
          if (column.property === 'click' || column.property === 'feedback' || column.property === 'phone' ||
            column.property === 'costCoin' || column.property === 'costMoney' || column.property === 'talk' ||
            column.property === 'total') {
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value) && value !== Infinity) {
                  return prev + curr
                } else {
                  return prev
                }
              }, 0)
            }
            if (column.property === 'costCoin') {
              sums[index] = sums[index].toFixed(2) + ' 点'
            }
            if (column.property === 'costMoney') {
              sums[index] = sums[index].toFixed(2) + ' 元'
            }
          }
        })
        return sums
      }
    }
  }
</script>

<style lang="scss" type="text/css" scoped>
  .tableTip{
    font-size: 12px;
    line-height: 25px;
    margin-bottom: 10px;
    color: red;
    span{
      width: 24px;
      display: inline-block;
    }
  }
  .listBox>.element-table>.el-table__footer-wrapper>.el-table__footer>has-gutter>tr>is-leaf>.cell{
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/client/PromoteData.vue